import { Component } from '@angular/core';

@Component({
  selector: 'app-new-account-desktop-finished-state',
  templateUrl: './new-account-desktop-finished-state.component.html',
  styleUrls: [
    '../../shared-styles/new-account-device-view.component.scss',
    './new-account-desktop-finished-state.component.scss',
  ],
  standalone: false,
})
export class NewAccountDesktopFinishedStateComponent {}
